(function() {
  'use strict';

  // Extend this map as you add colors. Keys are case-insensitive.
  const COLOR_HEX = {
    'black':     '#111111',
    'white':     '#F5F1EA',
    'ivory':     '#EDE6D3',
    'cream':     '#EFE7D5',
    'beige':     '#D8CBB4',
    'blue':      '#2B4A6F',
    'baby-blue': '#B4D0E7',
    'navy':      '#0F1F3D',
    'brown':     '#6B4423',
    'camel':     '#B4855A',
    'green':     '#3A5A3A',
    'red':       '#8B1A1A',
    'grey':      '#808080',
    'gray':      '#808080',
    'pink':      '#E7B4C0',
    'olive':     '#6B6B2A'
  };

  // Arabic colour names (storefront /ar) -> English keys used in image alt text.
  const AR_COLOR = {
    'أسود':'black','أبيض':'white','عاجي':'ivory','كريمي':'cream','بيج':'beige','أزرق':'blue',
    'لبني':'baby-blue','كحلي':'navy','بني':'brown','جملي':'camel','أخضر':'green','أحمر':'red',
    'رمادي':'grey','وردي':'pink','زيتي':'olive'
  };
  // Matches the colour option whether it is named "Color" or "اللون".
  const COLOR_SEL = 'input[name*="olor" i], select[name*="olor" i], input[name*="اللون"], select[name*="اللون"]';

  const norm  = s => { const t = String(s || '').trim(); return AR_COLOR[t] || t.toLowerCase().replace(/\s+/g, '-'); };
  const hexFor = n => COLOR_HEX[norm(n)] || null;

  // ---- PDP: filter gallery by current color -------------------------------
  function initPDP() {
    const isProduct = document.body.classList.contains('template-product')
      || document.body.classList.contains('product-template')
      || document.querySelector('main.product, main[data-product]');
    if (!isProduct) return;

    const colorInputs = document.querySelectorAll(COLOR_SEL);
    if (!colorInputs.length) return;

    function items() {
      return Array.from(document.querySelectorAll(
        '.product__media-item, .product__media-list > li, media-gallery li, [data-media-item]'
      ));
    }

    function currentColor() {
      const c = document.querySelector('input[name*="olor" i]:checked, input[name*="اللون"]:checked');
      if (c) return norm(c.value);
      const s = document.querySelector('select[name*="olor" i], select[name*="اللون"]');
      if (s) return norm(s.value);
      return null;
    }

    function filter() {
      const color = currentColor();
      if (!color) return;
      const others = Object.keys(COLOR_HEX).filter(c => norm(c) !== color && c !== 'gray');
      items().forEach(item => {
        const img = item.querySelector('img');
        const alt = img ? (img.getAttribute('alt') || '').toLowerCase() : '';
        const hasCurrent = alt.includes(color.replace('-', ' ')) || alt.includes(color);
        const hasOther   = others.some(c => alt.includes(c));
        const show = hasCurrent || (!hasCurrent && !hasOther);
        item.style.display = show ? '' : 'none';
      });
    }

    document.addEventListener('change', e => {
      if (e.target.matches && e.target.matches(COLOR_SEL)) {
        setTimeout(filter, 60);
      }
    });
    setTimeout(filter, 300);
  }

  // ---- Collection: inject swatches into product cards ---------------------
  function initCards() {
    const cards = document.querySelectorAll('.card-wrapper, .product-card, .grid__item .card');
    cards.forEach(card => {
      if (card.dataset.midSwatches) return;
      card.dataset.midSwatches = '1';

      const link = card.querySelector('a[href*="/products/"]');
      if (!link) return;
      const handle = link.getAttribute('href').split('/products/')[1].split(/[?/]/)[0];

      fetch('/products/' + handle + '.js').then(r => r.json()).then(product => {
        const opt = (product.options_with_values
          ? product.options_with_values.find(o => /color|اللون/i.test(o.name))
          : (product.options || []).map((n, i) => ({
              name: n,
              values: [...new Set(product.variants.map(v => v.options[i]))]
            })).find(o => /color|اللون/i.test(o.name)));
        if (!opt || !opt.values || opt.values.length < 2) return;

        const cardImg = card.querySelector('img');
        const origSrc = cardImg ? cardImg.getAttribute('src') : null;

        const wrap = document.createElement('div');
        wrap.className = 'midey-swatches';
        opt.values.forEach(val => {
          const value = typeof val === 'string' ? val : val.name;
          const variant = product.variants.find(v => v.options.includes(value));
          const hex = hexFor(value) || value.toLowerCase();
          const a = document.createElement('a');
          a.className = 'midey-swatches__dot';
          a.href = '/products/' + handle + (variant ? '?variant=' + variant.id : '');
          a.style.background = hex;
          a.setAttribute('aria-label', value);
          a.setAttribute('title', value);
          if (variant && variant.featured_image) {
            const swap = variant.featured_image.src;
            a.addEventListener('mouseenter', () => { if (cardImg) cardImg.src = swap; });
            a.addEventListener('mouseleave', () => { if (cardImg && origSrc) cardImg.src = origSrc; });
          }
          wrap.appendChild(a);
        });

        const price = card.querySelector('.price, .card__price, [data-price], .card-information');
        (price ? price.parentNode : card).appendChild(wrap);
      }).catch(() => {});
    });
  }

  function init() { initPDP(); initCards(); }
  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
  document.addEventListener('shopify:section:load', init);
})();
